import { render, staticRenderFns } from "./preQuestion.vue?vue&type=template&id=454e0ffb&scoped=true&"
import script from "./preQuestion.vue?vue&type=script&lang=js&"
export * from "./preQuestion.vue?vue&type=script&lang=js&"
import style0 from "./preQuestion.vue?vue&type=style&index=0&id=454e0ffb&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454e0ffb",
  null
  
)

export default component.exports